import React, { useEffect, useState } from "react";
import { Layout, Card, message, Button, Radio } from "antd";
import Sidebar from "./Sidebar";
import HeaderBar from "./HeaderBar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "./config";

const { Content, Sider } = Layout;

// Convert company name to slug
const toSlug = (name) =>
  name
    ? name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "")
    : "";

// ---------------------
// PRICING CARD
// ---------------------
const PricingCard = ({
  title,
  price,
  popular,
  features,
  onBuy,
  isSelected,
  onSelect,
  billingLabel,
}) => {
  return (
    <div style={{ width: 320 }}>
      {popular && (
        <div
          style={{
            background: "#006CFF",
            color: "#fff",
            textAlign: "center",
            padding: "6px 0",
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          Most popular
        </div>
      )}

      <Card
        onClick={onSelect}
        style={{
         
          borderRadius: 12,
          border: isSelected ? "2px solid #006CFF" : "1px solid #e3e7ee",
          boxShadow: isSelected
            ? "0px 0px 12px rgba(0,108,255,0.25)"
            : "0px 4px 14px rgba(0,0,0,0.08)",
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {/* TOP */}
        <div>
          <div style={{ textAlign: "center", marginBottom: 16 }}>
            <h2 style={{ margin: 0 }}>{title}</h2>
            <h1 style={{ margin: "12px 0", fontSize: 32 }}>
              ₹{price}
            </h1>
            <p style={{ color: "#6b788c" }}>{billingLabel}</p>
          </div>

          {features.map((item, idx) => (
            <p key={idx} style={{ margin: "6px 0" }}>
              • {item}
            </p>
          ))}
        </div>

        {/* FOOTER */}
        <Button
          type="primary"
          block
          size="large"
          style={{ borderRadius: 8, height: 45 }}
          onClick={(e) => {
            e.stopPropagation();
            onBuy();
          }}
        >
          Buy now
        </Button>
      </Card>
    </div>
  );
};

// ---------------------
// MAIN COMPONENT
// ---------------------
function Payment() {
  const [collapsed, setCollapsed] = useState(false);
  const [user, setUser] = useState(null);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [billingCycle, setBillingCycle] = useState("monthly"); // 🔑 NEW

  const navigate = useNavigate();

  // Load user
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  // Load plans
  useEffect(() => {
    fetch(`${BASE_URL}/plans.php`)
      .then((res) => res.json())
      .then((data) => {
        const formatted = Object.keys(data).map((key) => ({
          plan_key: key,
          ...data[key],
        }));
        setPlans(formatted);
      })
      .catch(() => message.error("Failed to load plans"));
  }, []);

  if (!user) return null;

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider collapsible collapsed={collapsed} onCollapse={setCollapsed}>
        <Sidebar collapsed={collapsed} user={user} />
      </Sider>

      <Layout>
        <HeaderBar title="View Pricing" />

        <Content style={{ margin: 16, background: "#f5f6fa" }}>
          {/* TOGGLE */}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 20,
            }}
          >
            <Radio.Group
              value={billingCycle}
              onChange={(e) => setBillingCycle(e.target.value)}
              buttonStyle="solid"
            >
              <Radio.Button value="monthly">Monthly</Radio.Button>
              <Radio.Button value="annual">Annual</Radio.Button>
            </Radio.Group>
          </div>

          {/* PRICING CARDS */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 20,
              flexWrap: "wrap",
            }}
          >
            {plans.map((plan) => {
              const price =
                billingCycle === "monthly"
                  ? plan.monthly
                  : plan.annualMonthly;

              const label =
                billingCycle === "monthly"
                  ? "/user per month"
                  : "/user per month (annual billing)";

              return (
                <PricingCard
                  key={plan.plan_key}
                  title={plan.title}
                  price={price}
                  billingLabel={label}
                  popular={plan.plan_key === "pro"}
                  features={[
                    `Annual Prepaid: ₹${plan.annualPrepaid}`,
                    "24/7 Support",
                  ]}
                  isSelected={selectedPlan === plan.plan_key}
                  onSelect={() => setSelectedPlan(plan.plan_key)}
                  onBuy={() =>
                    navigate(`/plan/${plan.plan_key}`, {
                      state: { plan },
                    })
                  }
                />
              );
            })}
          </div>
        </Content>

        <Footer user={user} />
      </Layout>
    </Layout>
  );
}

export default Payment;
